'use strict';

import * as types from '../../types';
import d3Api from '../../api/d3-api';
import awsApi from '../../api/aws-api';
import router from '../../../router';
import lineLiff from '../../../libs/line-liff';

export default {
  /**
   * スキャンデータを初期化
   * @param commit
   */
  [types.RESET_SCAN_DISC_DATA]: function({commit}){
    commit(types.RESET_SCAN_DISC_DATA);
  },
  
  // 画像をアップロードする
  [types.UPLOAD_CAMERA_IMAGE]({commit, rootState, dispatch}, {file}){
    function onUploadProgress(progressPercent){
      commit(types.CHANGE_UPLOADING_PROGRESS, {progressPercent});
    }
    
    dispatch(types.RESET_SCAN_DISC_DATA);
    commit(types.UPLOAD_CAMERA_IMAGE);
    
    awsApi.uploadImageToS3(file, rootState.auth.cognitoIdentityId, rootState.device, onUploadProgress)
      .then((fileName)=>{
        // stateにアップロード画像のファイル名を反映
        commit(types.UPLOAD_CAMERA_IMAGE_SUCCESS, {fileName});
        
        // 認識APIを呼ぶ
        //return d3Api.scanDisc(state.auth.credentials, fileName);
        return new Promise((resolve, reject)=>{
          d3Api.scanDisc(rootState.auth.credentials, fileName, lineLiff.getLineUserId())
            .then((discData)=>{
              // スキャンイベントを送信
              mixpanel.track('scan', {
                result: 'Success',
                name:   discData.name
              });
              
              // google analyticsにも
              ga('send', {
                hitType: 'event',
                eventCategory: 'badge',
                eventAction: 'scan',
                eventLabel: discData.name,
                dimension1: discData.lotId
              });
              
              resolve(discData);
            })
            .catch((err)=>{
              mixpanel.track('scan', {
                result: 'Failure'
              });
              reject(err);
            });
        });
      })
      .then((discData)=>{
        commit(types.RECEIVE_DISC_DATA, {discData});
      })
      .catch((err)=>{
        commit(types.UPLOAD_CAMERA_IMAGE_FAILURE);
        commit(types.RECEIVE_DISC_DATA_FAILURE, {data: err});
        logger('Error upload', err);
      });
  },
  
  /**
   * LINEでコンテンツゲット！
   * @param commit
   * @param rootState
   * @param dispatch
   * @param token
   * @param lineUserId
   */
  [types.GET_LINE_CONTENTS]({commit, rootState, dispatch}, {token}){
    new Promise((resolve, reject)=>{
      // d3Api.getLineContents(rootState.auth.credentials, token, lineLiff.getLineUserId())
      d3Api.getLineContents(rootState.auth.credentials, token, 'HHHHHH')
        .then((discData)=>{
          // // スキャンイベントを送信
          // mixpanel.track('scan', {
          //   result: 'Success',
          //   name:   discData.name
          // });
          //
          // // google analyticsにも
          // ga('send', {
          //   hitType: 'event',
          //   eventCategory: 'badge',
          //   eventAction: 'scan',
          //   eventLabel: discData.name,
          //   dimension1: discData.lotId
          // });
        
          resolve(discData);
        })
        .catch((err)=>{
          // mixpanel.track('scan', {
          //   result: 'Failure'
          // });
          reject(err);
        });
    })
      .then((discData)=>{
        commit(types.RECEIVE_DISC_DATA, {discData});
      })
      .catch((err)=>{
        commit(types.GET_LINE_CONTENTS_FAILURE);
        logger('Error upload', err);
      });
  },
  
  // SignedCookieをゲットする
  [types.GET_SIGNED_COOKIE]({commit, rootState, state, dispatch}, {content}){
    // クリアする
    dispatch(types.RESET_SIGNED_COOKIE);
    
    // SignedCookie取得
    if(state.discData){
      d3Api.getContentCredential(rootState.auth.credentials, state.discData.credentials, content.id, state.discData.id, state.discData.lotId)
        .then((result)=>{
          commit(types.GET_SIGNED_COOKIE_SUCCESS, {credentials: result.credentials});
        })
        .catch((err)=>{
          logger('$$$$$$$$', err);
        })
      ;
    }
  },
  
  // SignedCookieをリセットする
  [types.RESET_SIGNED_COOKIE]({commit}){
    commit(types.RESET_SIGNED_COOKIE);
  },
  
  /**
   * お問い合わせ送信
   * @param commit
   * @param email
   * @param name
   * @param message
   */
  [types.SEND_INQUIRY]: function({commit, rootState, dispatch}, {type, email, name, message}){
    commit(types.SEND_INQUIRY);
    
    d3Api.sendInquiry(rootState.auth.credentials, type, email, name, message)
      .then(()=>{
        commit(types.SEND_INQUIRY_SUCCESS);
        router.push({name: 'contactFinish'});
      })
      .catch((err)=>{
        logger(err);
        commit(types.SHOW_SNACK_BAR, {body: '問い合わせ送信に失敗しました。もう一度お試しいただくか、メールでお問い合わせください。'});
        commit(types.SEND_INQUIRY_FAILURE);
      });
  },
  
  /**
   * ドキュメントダウンロードするための情報送信
   * @param commit
   * @param email
   * @param name
   * @param message
   */
  [types.SEND_INFO_FOR_DOCUMENT_DOWNLOAD]: function({commit, rootState, dispatch}, {type, email, name, message}){
    commit(types.SEND_INFO_FOR_DOCUMENT_DOWNLOAD);
    
    d3Api.sendInquiry(rootState.auth.credentials, type, email, name, message)
      .then(()=>{
        commit(types.SEND_INFO_FOR_DOCUMENT_DOWNLOAD_SUCCESS);
        router.push({name: 'documentDownload'});
      })
      .catch((err)=>{
        logger(err);
        commit(types.SHOW_SNACK_BAR, {body: '問い合わせ送信に失敗しました。もう一度お試しいただくか、メールでお問い合わせください。'});
        commit(types.SEND_INFO_FOR_DOCUMENT_DOWNLOAD_FAILURE);
      });
  },
  
  /**
   * コンテンツ再生したとき〜（再生ログを送信する）
   * @param commit
   * @param rootState
   * @param contentId コンテンツID
   */
  [types.PLAY_CONTENT]: function({commit, rootState, state}, {contentId}){
    commit(types.PLAY_CONTENT);
    
    d3Api.playContent(rootState.auth.credentials, contentId, state.discData.id, state.discData.lotId)
      .then(()=>{
        commit(types.PLAY_CONTENT_SUCCESS);
      })
      .catch((err)=>{
        logger(err);
        commit(types.PLAY_CONTENT_FAILURE);
      });
  },
  
  /**
   * アンケート回答を送信
   * @param commit
   * @param rootState
   * @param state
   * @param answer
   * @param jwt
   * @returns {Promise}
   */
  [types.SEND_ANSWER]: function({commit, rootState, state}, {answer, jwt}){
    return new Promise((resolve, reject)=>{
      commit(types.SEND_ANSWER);
  
      d3Api.sendAnswer(rootState.auth.credentials, answer, jwt)
        .then(()=>{
          commit(types.SEND_ANSWER_SUCCESS);
          resolve();
        })
        .catch((err)=>{
          logger(err);
          commit(types.SEND_ANSWER_FAILURE);
          reject();
        });
    });
  },
  
  /**
   * コンテンツリストのスクロールポジションが変わった
   * @param commit
   * @param position スクロール位置
   */
  [types.UPDATE_CONTENTS_LIST_SCROLL_POSITION]: function({commit}, {position}){
    commit(types.UPDATE_CONTENTS_LIST_SCROLL_POSITION, {position});
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/d3/actions.js